import { render, staticRenderFns } from "./createClient.vue?vue&type=template&id=2508995e&scoped=true&"
import script from "./createClient.vue?vue&type=script&lang=js&"
export * from "./createClient.vue?vue&type=script&lang=js&"
import style0 from "./createClient.vue?vue&type=style&index=0&id=2508995e&scoped=true&lang=css&"
import style1 from "./createClient.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2508995e",
  null
  
)

export default component.exports